import {
  NewButton,
  NewButtonSize,
  NewButtonVariant,
  TooltipTrigger,
} from "@visiblethread/react-components";
import { idPropType } from "constants/app";
import { modalTypes } from "constants/types";
import { showSuccessAlert } from "layout/workspaceContextMenu/actions/helpers";
import { UnlinkIcon } from "lucide-react";
import { string } from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { showModal } from "slices/app/actions/modals";
import { detachDocument } from "slices/proposalOutline/actions/documentActions";
import {
  selectOutlineOwner,
  selectProposalOutlineSections,
} from "slices/proposalOutline/selectors";

const UnlinkButton = ({ nextgenDocumentId, nextgenFileName, sectionId }) => {
  const dispatch = useDispatch();
  const owner = useSelector(selectOutlineOwner);
  const sections = useSelector(selectProposalOutlineSections);

  const onConfirmDetach = async ({ deleteDocument, newDocumentName }) => {
    if (!owner) {
      return;
    }

    const outlineItemIdsToKeep = sections
      .filter((section) => section.nextgenDocumentId === nextgenDocumentId)
      .map((section) => section.id);

    const result = await dispatch(
      detachDocument(owner.ownerType, owner.ownerId, sectionId, {
        deleteDocument,
        newDocumentName,
        outlineItemIdsToKeep,
        outlineItemIdsToDelete: [],
        documentId: nextgenDocumentId,
      })
    );

    if (result) {
      showSuccessAlert(
        dispatch,
        deleteDocument
          ? "Document successfully deleted."
          : "Document link successfully removed."
      );
    }
  };

  const onClickDetach = (e) => {
    e.stopPropagation();
    dispatch(
      showModal(modalTypes.DETACH_DOCUMENT_MODAL, {
        documentName: nextgenFileName,
        onConfirm: onConfirmDetach,
      })
    );
  };

  return (
    <TooltipTrigger content="Unlink this document">
      <NewButton
        data-testid="unlink-doc-btn"
        leftIcon={<UnlinkIcon size={14} />}
        onClick={onClickDetach}
        size={NewButtonSize.sm}
        variant={NewButtonVariant.l3}
      ></NewButton>
    </TooltipTrigger>
  );
};

UnlinkButton.propTypes = {
  nextgenDocumentId: idPropType,
  nextgenFileName: string,
  sectionId: idPropType,
};

export default UnlinkButton;
